module.exports = __webpack_public_path__ + "static/media/computerDestroyed.61a824c2.gif";